import { styled } from "@mui/material/styles";
import { Box, Backdrop, Checkbox, Typography } from "@mui/material";
import { TaskAltOutlined } from "@mui/icons-material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const SectionTitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "bold",
  fontSize: "18px",
  color: theme.palette.text.primary,
  marginTop: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const ChecklistItemBox = styled(Box)({
  display: "block",
});

export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const UncheckedIcon = styled(TaskAltOutlined)(({ theme }) => ({
  color: theme.palette.text.primary,
  opacity: 0.3,
}));

export const CheckedIcon = styled(TaskAltOutlined)(({ theme }) => ({
  color: "#4ca551d9",
}));

export const LabelTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "18px",
  fontFamily: "'Quicksand', sans-serif",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const LinkTypography = styled(Typography)(({ theme }) => ({
  color: "rgb(51, 38, 29)",
  fontWeight: 600,
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  marginBottom: "10px",
  textDecoration: "underline",
  cursor: "pointer",
}));

export const FooterTypography = styled(Typography)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  fontStyle: "italic",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
